import axios from 'axios'
import { Message, Loading } from 'element-ui'

const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production') {
    const envBaseURL = process.env.VUE_APP_API_BASE_URL
    if (envBaseURL === 'USE_RELATIVE_PATH') {
      return ''
    }
    if (envBaseURL && envBaseURL !== 'USE_RELATIVE_PATH') {
      return envBaseURL
    }
    return 'http://8.130.215.242:8080'
  }
  return '/'
}

const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 如果是FormData类型文件上传，不设置Content-Type（让浏览器自动设置multipart/form-data）
    if (config.data instanceof FormData) {
      // 不要手动删除Content-Type，让浏览器自动设置正确的multipart boundary
      // delete config.headers['Content-Type']
    }
    
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.parse(new Date()) / 1000
      }
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 加载实例
let loadingInstance = null

// 错误信息转换函数
const translateErrorMessage = (message) => {
  if (!message) return '操作失败，请稍后重试'
  
  const msg = message.toLowerCase()
  
  // 重复数据错误
  if (msg.includes('duplicate') || msg.includes('唯一') || msg.includes('重复')) {
    return '数据已存在，请检查后重试'
  }
  
  // 数据不存在错误
  if (msg.includes('not found') || msg.includes('不存在') || msg.includes('无法找到')) {
    return '数据不存在，请刷新后重试'
  }
  
  // 外键约束错误
  if (msg.includes('foreign key') || msg.includes('外键') || msg.includes('constraint')) {
    return '数据关联失败，请检查关联数据'
  }
  
  // 空数据错误
  if (msg.includes('cannot be null') || msg.includes('不能为空')) {
    return '必填字段不能为空，请检查输入'
  }
  
  // 数据溢出错误
  if (msg.includes('out of range') || msg.includes('超出范围')) {
    return '数据超出范围，请检查输入'
  }
  
  // 数据格式错误
  if (msg.includes('format') || msg.includes('格式')) {
    return '数据格式错误，请检查输入'
  }
  
  // 登录过期
  if (msg.includes('expired') || msg.includes('过期') || msg.includes('失效')) {
    return '登录已过期，请重新登录'
  }
  
  // 权限错误
  if (msg.includes('permission') || msg.includes('权限') || msg.includes('denied')) {
    return '无权限操作，请联系管理员'
  }
  
  // 文件上传错误
  if (msg.includes('file') || msg.includes('upload') || msg.includes('图片')) {
    return '文件上传失败，请检查文件格式和大小'
  }
  
  // 服务器错误
  if (msg.includes('error updating database') || msg.includes('sql') || msg.includes('exception')) {
    return '系统繁忙，请稍后重试'
  }
  
  // 截取过长的错误信息
  if (message.length > 100) {
    return message.substring(0, 100) + '...'
  }
  
  return message
}

// response拦截器
service.interceptors.response.use(
  response => {
    // 关闭加载提示
    if (loadingInstance) {
      loadingInstance.close()
    }
    
    const res = response.data
    
    // 根据后端返回的数据格式进行判断
    if (res.code !== undefined) {
      // 统一状态码处理
      if (res.code !== 200 && res.code !== 0) {
        const friendlyMessage = translateErrorMessage(res.message)
        Message({
          message: friendlyMessage,
          type: 'error',
          duration: 3 * 1000
        })
        
        // 未授权或token过期
        if (res.code === 401) {
          // 清除token
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // 跳转到登录页
          window.location.href = '/login'
        }
        
        return Promise.reject(new Error(res.message || '请求失败'))
      } else {
        return res
      }
    } else if (res.success !== undefined) {
      // 处理包含success字段的返回格式
      if (res.success) {
        return res;
      } else {
        const friendlyMessage = translateErrorMessage(res.message)
        Message({
          message: friendlyMessage,
          type: 'error',
          duration: 3 * 1000
        });
        return Promise.reject(new Error(res.message || '请求失败'));
      }
    } else {
      // 如果后端没有返回统一格式，返回response.data
      return response.data
    }
  },
  error => {
    // 关闭加载提示
    if (loadingInstance) {
      loadingInstance.close()
    }
    
    console.error('响应错误:', error)
    
    // 网络错误提示
    let errorMessage = '网络异常，请稍后重试'
    
    if (error.response) {
      switch (error.response.status) {
        case 400: {
          // 如果有具体的错误信息，尝试转换
          const detailMessage = error.response.data?.message || error.response.data?.error
          errorMessage = translateErrorMessage(detailMessage) || '请求参数错误，请检查输入'
          break
        }
        case 401:
          errorMessage = '登录已过期，请重新登录'
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          setTimeout(() => {
            window.location.href = '/login'
          }, 1000)
          break
        case 403:
          errorMessage = '无权限操作，请联系管理员'
          break
        case 404:
          errorMessage = '请求的资源不存在'
          break
        case 408:
          errorMessage = '请求超时，请稍后重试'
          break
        case 422:
          errorMessage = '数据验证失败，请检查输入'
          break
        case 429:
          errorMessage = '操作过于频繁，请稍后重试'
          break
        case 500:
          errorMessage = '系统繁忙，请稍后重试'
          break
        case 502:
          errorMessage = '服务器暂时不可用，请稍后重试'
          break
        case 503:
          errorMessage = '服务维护中，请稍后再试'
          break
        default: {
          const responseMessage = error.response.data?.message || error.response.data?.error
          errorMessage = translateErrorMessage(responseMessage) || '请求失败，请稍后重试'
        }
      }
    } else if (error.request) {
      errorMessage = '网络连接失败，请检查网络'
    } else {
      errorMessage = translateErrorMessage(error.message) || '操作失败，请稍后重试'
    }
    
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3 * 1000
    })
    
    return Promise.reject(error)
  }
)

// 带加载状态的请求方法
export const requestWithLoading = (config = {}) => {
  // 显示加载状态
  if (config.loading !== false) {
    loadingInstance = Loading.service({
      lock: true,
      text: config.loadingText || '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  
  return service(config)
}

// 默认导出service实例
export default service
